import { useWithAmpli } from '@contexts/AmpliContextProvider'
import { Button, type ButtonProps } from '@mui/material'
import * as React from 'react'

export type CustomButtonProps<D extends React.ElementType> = {
	eventText: string
} & ButtonProps<D>

export const TrackableButton = <D extends React.ElementType>({
	eventText,
	children,
	onClick,
	...rest
}: CustomButtonProps<D>) => {
	const withAmpli = useWithAmpli()
	const handleButtonClick = React.useCallback(
		(event: React.MouseEvent<HTMLButtonElement>) => {
			if (eventText) {
				withAmpli(ampli =>
					ampli.clickEvent({
						buttonText: eventText,
						clickPageUrl: window.location.href,
					})
				)
			}

			if (onClick) {
				onClick(event)
			}
		},
		[eventText, onClick, withAmpli]
	)

	return (
		<Button {...rest} onClick={handleButtonClick}>
			{children}
		</Button>
	)
}
